type IdleCallbackHandle = number;

interface IdleDeadline {
  readonly didTimeout: boolean;
  timeRemaining: () => DOMHighResTimeStamp;
}

type IdleCallback = (deadline: IdleDeadline) => void;

const activeHandles = new Set<IdleCallbackHandle>();

export function requestIdleCallback(
  callback: IdleCallback,
  _options?: { timeout?: number },
): IdleCallbackHandle {
  const start = performance.now();
  const timeoutId = setTimeout(() => {
    const handle = timeoutId as unknown as number;
    activeHandles.delete(handle);
    try {
      callback({
        didTimeout: false,
        timeRemaining: () => {
          const elapsed = performance.now() - start;
          return Math.max(0, 50 - elapsed);
        },
      });
    } catch (error) {
      console.error('[requestIdleCallback] Error in callback:', error);
    }
  }, 0);
  const handle = timeoutId as unknown as number;
  activeHandles.add(handle);
  return handle;
}

export function cancelIdleCallback(id: IdleCallbackHandle) {
  if (activeHandles.has(id)) {
    clearTimeout(id);
    activeHandles.delete(id);
  }
}
